import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import addonApiController from "../../services/addon.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import { contentErrorMessage } from "./contentError";

const addonErrorMessage = (action, fallback) => contentErrorMessage(action, fallback);

export const AddOnServicesApi = createAsyncThunk("addon/addonservices", async (formValues, thunkAPI) => {
  try {
    const resposedata = await addonApiController
      .services(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "addonservices"))
      .catch((error) => HandleError(thunkAPI, error, "addonservices"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const AddOnServicePriceApi = createAsyncThunk("addon/addonserviceprice", async (formValues, thunkAPI) => {
  try {
    const resposedata = await addonApiController
      .serviceprice(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "addonserviceprice"))
      .catch((error) => HandleError(thunkAPI, error, "addonserviceprice"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const AddonStaffOptionsApi = createAsyncThunk("addon/addonstaffOptions", async (formValues, thunkAPI) => {
  try {
    const resposedata = await addonApiController
      .staff(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "addonstaffOptions"))
      .catch((error) => HandleError(thunkAPI, error, "addonstaffOptions"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const StaffAvailableTimeApi = createAsyncThunk("addon/StaffAvailableTime", async (formValues, thunkAPI) => {
  try {
    const resposedata = await addonApiController
      .staffavailabletime(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "StaffAvailableTime"))
      .catch((error) => HandleError(thunkAPI, error, "StaffAvailableTime"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});
export const ResourceAvailableTimeApi = createAsyncThunk("addon/ResourceAvailableTime", async (formValues, thunkAPI) => {
  try {
    const resposedata = await addonApiController
      .resourceavailabletime(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "AddonResourceAvailableTime"))
      .catch((error) => HandleError(thunkAPI, error, "AddonResourceAvailableTime"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});


export const AddOnResourceOptionsApi = createAsyncThunk("addon/resourceOptions", async (formValues, thunkAPI) => {
  try {
    const resposedata = await addonApiController
      .addonserviceresourceitems(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "addonresourceOptions"))
      .catch((error) => HandleError(thunkAPI, error, "addonresourceOptions"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  availabilityRequestId: null,
  isAddOn: [], //{ serviceprice: "", services: [], staff: [], duration: "", cost: "" }
  isAddOnServices: [],
  isAddOnServicesError: "",
  isAddOnServicePrice: [],
  isAddOnServicePriceError: "",
  isAddonStaffOptions: [],
  isAddonStaffOptionsError: "",
  isAddOnResourceOptions: [],
  isAddOnResourceOptionsError: "",
  isStaffAvailableTime: [],
  isStaffAvailableTimeError: "",
  isResourceAvailableTime: [],
  isResourceAvailableTimeError: "",
  isApiStatus: {
    AddOnServicesApi: "",
    AddOnServicePriceApi: "",
    AddonStaffOptionsApi: "",
    AddOnResourceOptionsApi: "",
    StaffAvailableTimeApi: "",
    ResourceAvailableTimeApi: "",
  },
};

const addonSlice = createSlice({
  name: "service",
  initialState,
  reducers: {
    reset: () => initialState,
    AddOnData: (state, action) => {
      if (action.payload) {
        const { id, ...changes } = action.payload;
        const existingData = state.isAddOn.find((event) => event.id === id);
        if (existingData) {
          Object.keys(changes).map((keyName) => {
            existingData[keyName] = changes[keyName];
          });
        } else {
          state.isAddOn = [...state.isAddOn, action.payload];
        }
      } else {
        state.isAddOn = [];
      }
    },
    AddOnDataRemove: (state, action) => {
      const { id } = action.payload;
      state.isApiStatus = { ...state.isApiStatus, serviceDeleteApi: "succeeded" };
      const newisAddOn = state.isAddOn ? state.isAddOn.filter((item) => item.id != id) : state.isAddOn.filter((item) => item.id != id);
      state.isAddOn = newisAddOn.map((item, index) => ({ ...item, id: index + 1 }));
    },
  },
  extraReducers:(builder)=> {
    builder
    .addCase(AddOnServicesApi.pending, (state) => {
      state.isAddOnServicesError = "";
      state.isApiStatus = { ...state.isApiStatus, AddOnServicesApi: "loading" };
    })
    .addCase(AddOnServicesApi.fulfilled, (state, action) => {
      state.isAddOnServices = action.payload;
      state.isAddOnServicesError = "";
      state.isApiStatus = { ...state.isApiStatus, AddOnServicesApi: "succeeded" };
    })
    .addCase(AddOnServicesApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, AddOnServicesApi: "failed" };
      state.isAddOnServicesError = addonErrorMessage(action, "Unable to load add-on services.");
    })
    .addCase(AddOnServicePriceApi.pending, (state) => {
      state.isAddOnServicePriceError = "";
      state.isApiStatus = { ...state.isApiStatus, AddOnServicePriceApi: "loading" };
    })
    .addCase(AddOnServicePriceApi.fulfilled, (state, action) => {
      state.isAddOnServicePrice = action.payload;
      state.isAddOnServicePriceError = "";
      state.isApiStatus = { ...state.isApiStatus, AddOnServicePriceApi: "succeeded" };
    })
    .addCase(AddOnServicePriceApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, AddOnServicePriceApi: "failed" };
      state.isAddOnServicePriceError = addonErrorMessage(action, "Unable to load add-on service prices.");
    })
    .addCase(AddonStaffOptionsApi.pending, (state) => {
      state.isAddonStaffOptionsError = "";
      state.isApiStatus = { ...state.isApiStatus, AddonStaffOptionsApi: "loading" };
    })
    .addCase(AddonStaffOptionsApi.fulfilled, (state, action) => {
      state.isAddonStaffOptions = action.payload;
      state.isAddonStaffOptionsError = "";
      state.isApiStatus = { ...state.isApiStatus, AddonStaffOptionsApi: "succeeded" };
    })
    .addCase(AddonStaffOptionsApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, AddonStaffOptionsApi: "failed" };
      state.isAddonStaffOptionsError = addonErrorMessage(action, "Unable to load add-on staff options.");
    })
    .addCase(AddOnResourceOptionsApi.pending, (state) => {
      state.isAddOnResourceOptionsError = "";
      state.isApiStatus = { ...state.isApiStatus, AddOnResourceOptionsApi: "loading" };
    })
    .addCase(AddOnResourceOptionsApi.fulfilled, (state, action) => {
      state.isAddOnResourceOptions = action.payload;
      state.isAddOnResourceOptionsError = "";
      state.isApiStatus = { ...state.isApiStatus, AddOnResourceOptionsApi: "succeeded" };
    })
    .addCase(AddOnResourceOptionsApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, AddOnResourceOptionsApi: "failed" };
      state.isAddOnResourceOptionsError = addonErrorMessage(action, "Unable to load add-on resource options.");
    })
    .addCase(StaffAvailableTimeApi.pending, (state, action) => {
        state.availabilityRequestId = action.meta.requestId;
      state.isStaffAvailableTimeError = "";
      state.isApiStatus = { ...state.isApiStatus, StaffAvailableTimeApi: "loading" };
    })
    .addCase(StaffAvailableTimeApi.fulfilled, (state, action) => {
        if (action.meta?.requestId && state.availabilityRequestId !== action.meta.requestId) return;
      state.isStaffAvailableTime = action.payload;
      state.isStaffAvailableTimeError = "";
      state.isApiStatus = { ...state.isApiStatus, StaffAvailableTimeApi: "succeeded" };
    })
    .addCase(StaffAvailableTimeApi.rejected, (state, action) => {
        if (action.meta?.requestId && state.availabilityRequestId !== action.meta.requestId) return;
      state.isApiStatus = { ...state.isApiStatus, StaffAvailableTimeApi: "failed" };
      state.isStaffAvailableTimeError = addonErrorMessage(action, "Unable to load add-on availability.");
    })
    .addCase(ResourceAvailableTimeApi.pending, (state) => {
      state.isResourceAvailableTimeError = "";
      state.isApiStatus = { ...state.isApiStatus, ResourceAvailableTimeApi: "loading" };
    })
    .addCase(ResourceAvailableTimeApi.fulfilled, (state, action) => {
      state.isResourceAvailableTime = action.payload;
      state.isResourceAvailableTimeError = "";
      state.isApiStatus = { ...state.isApiStatus, ResourceAvailableTimeApi: "succeeded" };
    })
    .addCase(ResourceAvailableTimeApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, ResourceAvailableTimeApi: "failed" };
      state.isResourceAvailableTimeError = addonErrorMessage(action, "Unable to load add-on resource availability.");
    });  
  },
});
// Action creators are generated for each case reducer function
export const { reset, AddOnData, AddOnDataRemove } = addonSlice.actions;
export default addonSlice.reducer;
